import React from 'react';
import { Card } from 'semantic-ui-react';
import { Link } from 'react-router-dom';

import webPropsImg from '../static/web-properties-app.jpg';
import * as routes from '../routes.json';

const apps = [
  {
    header: 'TWR Web Properties',
    description:
      'A report of sessions and users covering all web properties for TWR.',
    image: webPropsImg,
    to: routes.allWebProperties,
  },
];

const AppFeed = () => (
  <Card.Group itemsPerRow="3" stackable>
    {apps.map(app => (
      <Card
        key={app.header}
        image={app.image}
        header={app.header}
        as={Link}
        to={app.to}
        description={app.description}
      />
    ))}
  </Card.Group>
);

export default AppFeed;



// WEBPACK FOOTER //
// ./src/components/AppFeed.jsx